export default {"src":"https://marketing-edge-assets.lemonade.com/_next/static/media/leaks.b4e816aa.svg","height":68,"width":69,"blurWidth":0,"blurHeight":0};